export const useCheckForNewToken = () => {
    const checkForNewToken = (data, setUserJWT, setUserInfo ,setUser, setUserIndex, navigate , setMessageContent) => {
        if (data.newToken) {
            setUserJWT(data.newToken);
            localStorage.setItem("user token", data.newToken);
        }

        if (data.signIn) {
            setUser("");
            setUserInfo({});
            setUserIndex(-1);
            localStorage.removeItem("user");
            localStorage.removeItem("user token");
            navigate("/sign-in")
            setMessageContent({
                title: "Inactive user",
                message: "You have been inactive on this website for 7 days or more, so you need to sign in again.",
            })
        }
    };

    return { checkForNewToken };
};